import { render, staticRenderFns } from "./FormularioMosaicos.vue?vue&type=template&id=debeeb36&"
import script from "./FormularioMosaicos.vue?vue&type=script&lang=js&"
export * from "./FormularioMosaicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports